import React, {Component} from "react";
import {toast} from "react-toastify";
import DefaultUser from "../../../../assets/img/icons/addphoto.png";
import avatar from "../../../../assets/img/icons/avatar.png";
import ApiConnect from "../../../../Utils/ApiConnect";

class NewEmployee extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formError: null,
      Fdata: [],
      previewAvatar: avatar,
      Avatar: null,
      previewDoc: [],
      DocsUpload: [],
      btnDisable: false,
    };
  }

  handleChange_Avatar(e) {
    if (e.target.files) {
      const fileArray = URL.createObjectURL(e.target.files[0]);
      this.setState({ Avatar: e.target.files[0], previewAvatar: fileArray });
    }
  }
  handleChange_Docs(e) {
    if (e.target.files) {
      const fileArray = Array.from(e.target.files).map((file) =>
        URL.createObjectURL(file)
      );
      this.setState({ DocsUpload: e.target.files, previewDoc: fileArray });
      console.log(e.target.files);
    }
  }

  handleChange(e) {
    const newData = { ...this.state.Fdata };
    newData[e.target.name] = e.target.value;
    this.setState({ Fdata: newData });
  }
  submitHandler(e) {
    e.preventDefault();
    this.setState({ btnDisable: true });
    let formData = new FormData();
    formData.append("first_name", this.state.Fdata.first_name || "");
    formData.append("last_name", this.state.Fdata.last_name || "");
    formData.append("gender", this.state.Fdata.gender || "");
    formData.append("blood_group", this.state.Fdata.blood_group || "");
    formData.append("dob", this.state.Fdata.dob || "");
    formData.append("doc_type", this.state.Fdata.doc_type || "");
    formData.append("doc_no", this.state.Fdata.doc_no || "");
    formData.append("address", this.state.Fdata.address || "");
    formData.append("contact", this.state.Fdata.contact || "");
    formData.append("alt_contact", this.state.Fdata.alt_contact || "");
    formData.append("email", this.state.Fdata.email || "");
    formData.append("doj", this.state.Fdata.doj || "");
    formData.append("department", this.state.Fdata.department || "");
    formData.append("position", this.state.Fdata.position || "");
    formData.append("qualification", this.state.Fdata.qualification || "");
    formData.append("training", this.state.Fdata.training || "");
    formData.append("experience", this.state.Fdata.experience || "");
    formData.append("avatar_file", this.state.Avatar);
    for (let i = 0; i < this.state.DocsUpload.length; i++) {
      formData.append("images_files[]", this.state.DocsUpload[i]);
    }
    ApiConnect({
      method: "post",
      url: "/Module/Utilities/Employee/NewEmployee",
      data: formData,
    })
      .then((response) => {
        if (response.data.status === 201) {
          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
          this.setState({
            formError: null,
            Fdata: [],
            previewAvatar: avatar,
            Avatar: null,
            previewDoc: [],
            DocsUpload: [],
            btnDisable: false,
          });
        } else {
          this.setState({ formError: response.data.message });
        }
      })
      .catch((error) => console.log(error));
  }

  render() {
    return (
      <form onSubmit={(e) => this.submitHandler(e)}>
        <p className="text-danger">{this.state.formError}</p>
        <div className="row g-3 mb-3">
          <div className="col-xl-4 col-lg-4">
            <div className="card mb-3">
              <div className="card-header py-3 d-flex justify-content-between align-items-center bg-transparent border-bottom-0">
                <h6 className="m-0 fw-bold">Documents</h6>
              </div>
              <div className="card-body">
                <div className="row g-3 align-items-center">
                  <div className="col-md-12">
                    <div className="flexbox gap-items-4">
                      <img
                        className="img-thumbnail"
                        src={this.state.previewAvatar}
                        alt="Employee Profile"
                        width="130"
                        height="130"
                      />
                      <div className="flex-grow">
                        <h5>Employee Profile</h5>
                        <div className="flexbox justify-content-start mt-16">
                          <div className="file-group file-group-inline">
                            <input
                              type="file"
                              id="avatar_file"
                              name="avatar_file"
                              accept="image/*"
                              onChange={(e) => this.handleChange_Avatar(e)}
                              required
                            />
                            <label
                              htmlFor="avatar_file"
                              className="btn btn-sm btn-bold btn-primary file-browser"
                              type="button"
                            >
                              {" "}
                              Upload
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br />
                  <hr className="mb-0" />
                  <div className="col-md-12">
                    <h5>Employee Documents</h5>
                    <div className="row">
                      <div className="col file-group file-group-inline">
                        <input
                          type="file"
                          name="upload_doc"
                          accept="image/*"
                          multiple
                          onChange={(e) => this.handleChange_Docs(e)}
                          id="upload_doc"
                          required
                        />
                        <label htmlFor="upload_doc" className="btn b-0">
                          <img
                            src={DefaultUser}
                            name="images_files[]"
                            className="img-thumbnail"
                            width="130"
                            alt="User"
                          />
                        </label>
                      </div>
                      <div className="col">
                        {this.state.previewDoc.map((image, index) => (
                          <img
                            className="img-thumbnail"
                            src={image}
                            width="130"
                            height="130"
                            key={index}
                            alt={`doc${index}`}
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xl-8 col-lg-8">
            <div className="card mb-3">
              <div className="card-header py-3 d-flex justify-content-between bg-transparent border-bottom-0">
                <h6 className="mb-0 fw-bold ">Basic information</h6>
              </div>
              <div className="card-body">
                <div className="row g-3 align-items-center">
                  <div className="col-md-6">
                    <label className="form-label">First Name</label>
                    <input
                      type="text"
                      name="first_name"
                      value={this.state.Fdata.first_name || ""}
                      className="form-control"
                      placeholder="Oculus"
                      onChange={(e) => this.handleChange(e)}
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Last Name</label>
                    <input
                      type="text"
                      name="last_name"
                      value={this.state.Fdata.last_name || ""}
                      className="form-control"
                      placeholder="VR"
                      onChange={(e) => this.handleChange(e)}
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Gender</label>
                    <select
                      name="gender"
                      className="form-control"
                      value={this.state.Fdata.gender || ""}
                      onChange={(e) => this.handleChange(e)}
                      required
                    >
                      <option>Select Gender</option>
                      <option value="M">Male</option>
                      <option value="F">Female</option>
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Blood Group</label>
                    <input
                      type="text"
                      className="form-control"
                      value={this.state.Fdata.blood_group || ""}
                      placeholder="+A"
                      name="blood_group"
                      onChange={(e) => this.handleChange(e)}
                      required
                    />
                  </div>

                  <div className="col-md-3">
                    <label className="form-label">Date Of Birth</label>
                    <input
                      type="date"
                      className="form-control"
                      value={this.state.Fdata.dob || ""}
                      placeholder="YYYY-MM-DD"
                      name="dob"
                      onChange={(e) => this.handleChange(e)}
                      required
                    />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Documents Type</label>
                    <select
                      name="doc_type"
                      className="form-control"
                      value={this.state.Fdata.doc_type || ""}
                      onChange={(e) => this.handleChange(e)}
                      required
                    >
                      <option>Document Type</option>
                      <option value="Citizenship">Citizenship</option>
                      <option value="Driving License">Driving license</option>
                      <option value="Voter ID">Voter ID</option>
                      <option value="Others">Others</option>
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Documents Number</label>
                    <input
                      className="form-control"
                      name="doc_no"
                      value={this.state.Fdata.doc_no || ""}
                      placeholder="1234567890"
                      type="text"
                      onChange={(e) => this.handleChange(e)}
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Address</label>
                    <input
                      className="form-control"
                      name="address"
                      value={this.state.Fdata.address || ""}
                      placeholder="My Address"
                      type="text"
                      onChange={(e) => this.handleChange(e)}
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Contact</label>
                    <input
                      className="form-control"
                      name="contact"
                      value={this.state.Fdata.contact || ""}
                      placeholder="1234567890"
                      type="text"
                      onChange={(e) => this.handleChange(e)}
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Alternative Contact</label>
                    <input
                      className="form-control"
                      name="alt_contact"
                      value={this.state.Fdata.alt_contact || ""}
                      placeholder="1234567890"
                      type="text"
                      onChange={(e) => this.handleChange(e)}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Email</label>
                    <input
                      className="form-control"
                      name="email"
                      value={this.state.Fdata.email || ""}
                      placeholder="example@example.com"
                      type="email"
                      onChange={(e) => this.handleChange(e)}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="card mb-3">
              <div className="card-header py-3 d-flex justify-content-between bg-transparent border-bottom-0">
                <h6 className="mb-0 fw-bold ">Other Information</h6>
              </div>
              <div className="card-body">
                <div className="row g-3 align-items-center">
                  <div className="col-md-6">
                    <label className="form-label">Date of Joining</label>
                    <input
                      className="form-control"
                      name="doj"
                      type="date"
                      value={this.state.Fdata.doj || ""}
                      onChange={(e) => this.handleChange(e)}
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Department</label>
                    <input
                      className="form-control"
                      name="department"
                      value={this.state.Fdata.department || ""}
                      type="text"
                      onChange={(e) => this.handleChange(e)}
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Position</label>
                    <input
                      className="form-control"
                      name="position"
                      value={this.state.Fdata.position || ""}
                      type="text"
                      onChange={(e) => this.handleChange(e)}
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Qualification</label>
                    <input
                      className="form-control"
                      name="qualification"
                      value={this.state.Fdata.qualification || ""}
                      type="text"
                      onChange={(e) => this.handleChange(e)}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Training</label>
                    <input
                      className="form-control"
                      name="training"
                      value={this.state.Fdata.training || ""}
                      type="text"
                      onChange={(e) => this.handleChange(e)}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Experience Year</label>
                    <input
                      className="form-control"
                      name="experience"
                      value={this.state.Fdata.experience || ""}
                      type="number"
                      onChange={(e) => this.handleChange(e)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer className="card-footer flexbox flex-justified text-center">
          <button
            className="btn btn-success text-white fw-500"
            disabled={this.state.btnDisable}
          >
            Save
          </button>
        </footer>
      </form>
    );
  }
}

export default NewEmployee;
